<template>
  <div
    class="bg-surface shadow-xl relative flex flex-1 flex-col"
    :class="{
      'rounded-3xl': !channelStore.isAsMonacoFanToken,
      'w-[312px] max-w-full min-h-[464px]': !variant || variant === 'regular',
      'w-full ': variant === 'responsive',
    }"
  >
    <div
      class="flex flex-col flex-1 shadow-[inset_6px_7px_14px_0px_rgba(0,0,0,0.25)] gap-4 bg-surface border-[3px] border-border-brand overflow-hidden pt-3"
      :class="{ 'rounded-3xl': !channelStore.isAsMonacoFanToken }"
    >
      <!-- Main content area -->
      <div class="flex-1 flex flex-col p-4 gap-4">
        <!-- Title area -->
        <div class="flex flex-col gap-2">
          <Skeleton
            :width="titleWidths[skeletonIndex % titleWidths.length]"
            height="24px"
            border-radius="4px"
          />
          <Skeleton
            :width="subtitleWidths[skeletonIndex % subtitleWidths.length]"
            height="16px"
            border-radius="4px"
          />
        </div>

        <!-- Prize/Image area -->
        <div class="flex-1 flex items-center justify-center">
          <Skeleton width="100%" height="180px" border-radius="12px" />
        </div>

        <!-- Action buttons area -->
        <div class="flex gap-2">
          <Skeleton width="100%" height="40px" border-radius="20px" />
        </div>
      </div>
    </div>

    <!-- User section -->
    <div
      class="h-16 p-4 justify-between items-center inline-flex w-full shadow-2xl"
      :class="{ 'rounded-b-3xl': !channelStore.isAsMonacoFanToken }"
    >
      <div
        class="w-full grow shrink basis-0 h-8 justify-between items-start flex"
      >
        <div class="flex-1 justify-start items-center gap-2 flex">
          <Skeleton width="32px" height="32px" border-radius="50%" />
          <Skeleton
            :width="usernameWidths[skeletonIndex % usernameWidths.length]"
            height="16px"
            border-radius="4px"
          />
        </div>

        <div class="flex flex-row gap-2 shrink-0">
          <Skeleton width="32px" height="32px" border-radius="50%" />
          <Skeleton width="32px" height="32px" border-radius="50%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
import { computed } from "vue";
import { useChannelStore } from "@/stores/channel.store";

const props = defineProps<{
  variant?: "responsive" | "regular";
  index?: number;
}>();

const channelStore = useChannelStore();

// Different widths for variety in skeleton appearance
const titleWidths = ["85%", "75%", "90%"];
const subtitleWidths = ["65%", "55%", "70%"];
const usernameWidths = ["80px", "100px", "90px"];

const skeletonIndex = computed(() => props.index ?? 0);
</script>
